export default function ReloadCircle({ className, backgroundColor }) {
    return (
      <svg className={className} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="16" cy="16" r="16" fill={backgroundColor} />
        <path d="M11 16.5015C11 19.263 13.2385 21.5015 16 21.5015C18.7615 21.5015 21 19.263 21 16.5015C21 13.7399 18.7615 11.5015 16 11.5015H14.8476"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round" />
        <path d="M15.9 14L12.9 11.5044L15.9 9"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round" />
      </svg>

    )
}
